const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgBook = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 429.623 429.623",
    style: {
      enableBackground: "new 0 0 429.623 429.623"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    className: "",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M192.512,77.34c-48.64-25.088-105.984-25.088-154.624-0.512L8.192,92.188C3.072,94.748,0,99.868,0,106.012v249.856    c0,8.704,6.656,15.36,15.36,15.36c2.56,0,4.608-0.512,7.168-1.536l29.696-15.36c39.424-20.48,86.528-20.48,125.952,0    l21.504,11.264V80.924L192.512,77.34z",
    "data-original": "#000000",
    className: "active-path",
    style: {
      fill: "#4B7804"
    },
    "data-old_color": "#000000"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M421.888,92.188l-29.696-15.36c-48.64-24.576-105.984-24.576-154.112,0l-7.68,3.584v284.16l21.504-10.752    c39.424-20.48,86.528-20.48,125.952,0l29.696,15.36c7.68,4.096,16.896,1.024,20.48-6.656c1.024-2.048,1.536-4.608,1.536-7.168    V106.012C430.08,99.868,427.008,94.748,421.888,92.188z",
    "data-original": "#000000",
    className: "active-path",
    style: {
      fill: "#4B7804"
    },
    "data-old_color": "#000000"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBook, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/book.538fb505.svg";
export { ForwardRef as ReactComponent };